<div class="form-group" >
  <label *ngIf="label" [for]="id" class="control-label">{{ label }}</label>
  
  <div class="input-group" >
    
    <input 
      [ngClass]="{'form-control': true, 'is-invalid': isInvalid}"
      type="text" 
      [placeholder]="placeholder"
      [disabled]="disabled"
      [attr.maxlength]="getMaxLength()" 
      [required]="required"
      [id]="id"
      [(ngModel)]="displayValue" 
      (focus)="onFocus()"
      (blur)="onBlur($event)"
      (keypress)="onKeyPress($event)"
      (input)="onInput($event)"
    >

    <div class="input-group-append" *ngIf="type === 'zip'">
      <button 
        class="btn btn-custom-validate" 
        type="button" 
        [disabled]="disabled"
        (click)="validateZip()">
        Validar
      </button>
    </div>

    <div class="invalid-feedback" *ngIf="isInvalid">
      {{ errorMsg }}
    </div>

  </div>
</div>